import { Component, inject, Input, OnInit } from '@angular/core';
import { SharedModule } from 'primeng/api';
import { TableHeaderComponent } from '../table-header/table-header.component';
import { TableModule } from 'primeng/table';
import { Company, CompanyEnum } from '../../models/company.model';
import { JuniorPriceListPackage } from '../../models';
import { CourseDataTable, CourseTableLabels, Note } from '../../models/types';
import { getBandFromMinMax } from '../../utils/table-utils';
import { JuniorCampsPackagesBandsService } from '../../services/junior-camps-packages-bands.service';
import { CourseTableComponent } from '../course-table/course-table.component';
import { Currency } from '../../models/currency.model';
import { NgIf } from '@angular/common';
import { NotesComponent } from '../notes/notes.component';
import { PriceListNote } from '../../models/priceslist-note.model';
import { SubjectEnum } from '../../utils/notes.utils';
import { NotesService } from '../../services/notes.service';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-camps-course-table',
  templateUrl: './camps-course-table.component.html',
  styleUrls: ['./camps-course-table.component.scss'],
  imports: [SharedModule, TableHeaderComponent, TableModule, CourseTableComponent, NgIf, NotesComponent],
})
export class CampsCourseTableComponent implements OnInit {
  @Input() packages: JuniorPriceListPackage[] | undefined;
  @Input() courseNotes: PriceListNote[] = [];
  @Input() currency: Currency | undefined;
  @Input() company: Company = CompanyEnum.ALP;
  @Input() courseNotesSubject: SubjectEnum = SubjectEnum.COURSES;

  data: CourseDataTable[] = [];
  columnLabels: CourseTableLabels | undefined;
  notes: Note[] = [];

  private readonly juniorCampsPackagesBandsService = inject(JuniorCampsPackagesBandsService);
  private readonly notesService = inject(NotesService);

  ngOnInit(): void {
    this.data = this.packages.reduce<CourseDataTable[]>((processedCourses, course) => {
      const prices = course.prices.reduce<Record<string, number>>((prices, { price, duration: { min, max } }) => {
        const newPrices = { ...prices };
        newPrices[getBandFromMinMax(min, max)] = price;
        return newPrices;
      }, {});
      return [
        ...processedCourses,
        {
          name: course.name ?? '',
          prices,
        },
      ];
    }, []);

    this.columnLabels = this.juniorCampsPackagesBandsService.getColumnLabels(this.packages);

    const extractedCourseNotes = this.notesService.getNotes(this.courseNotes, this.courseNotesSubject);
    if (extractedCourseNotes) {
      [this.notes] = extractedCourseNotes;
    }
  }
}
